import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OccupationalProfileCompetencesComponent} from "./occupational-profile-competences.component";
import {OccupationalProfileCompetenceItemComponent} from "./competence/occupational-profile-competence-item.component";
import {OccupationalProfileCompetenceComponent} from "./competence/occupational-profile-competence.component";
import {OccupationalProfileSoftSkillComponent} from "./soft-skill/occupational-profile-soft-skill.component";
import {OccupationalProfileSoftSkillItemComponent} from "./soft-skill/occupational-profile-soft-skill-item.component";

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
    ],
    declarations: [
        OccupationalProfileCompetencesComponent,
        OccupationalProfileCompetenceItemComponent,
        OccupationalProfileCompetenceComponent,
        OccupationalProfileSoftSkillComponent,
        OccupationalProfileSoftSkillItemComponent
    ],
    exports: [
        OccupationalProfileCompetencesComponent
    ]
})

export class CompetencesModule {

}
